import { Pipe, PipeTransform } from '@angular/core';

///Return this format:             'dd/MM/yyyy hh:mm'
@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe implements PipeTransform {
  transform(value: any, args: string[]): any {
    if (value) {
      var date = value instanceof Date ? value : new Date(value);

      //WITH MINUTES
      return `${date.getDate() < 10 ? '0' + date.getDate() : date.getDate()}/${
        date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      }/${date.getFullYear() < 10 ? '0' + date.getFullYear() : date.getFullYear()} ${
        date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      }:${date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()}`;

      //WITHOUT MINUTES
      //return `${date.getDate() < 10 ? "0" + date.getDate() : date.getDate()}/${date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1}/${date.getFullYear() < 10 ? "0" + date.getFullYear() : date.getFullYear()} ${date.getHours() < 10 ? "0" + date.getHours() : date.getHours()} hs`;
    }
  }
}
